import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const packageSlice = createApi({
    reducerPath: "packageSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {

                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        
        getPackages: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/package?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        getCategoryBasedServices: builder.mutation({
            query: (id) => ({
                url: `/subcategoryType/category/${id}`,
                method: "GET",

            }),
        }),
        // ✅ Add New Category
        addPackage: builder.mutation({
            query: (body) => ({
                url: "/package",
                method: "POST",
                body,
            }),
        }),

        getSinglePackage: builder.query({
            query: (id) => ({
                url: `/package/${id}`,
                method: "GET",
            }),
        }),

        // ✅ Update Existing Category
        updatePackage: builder.mutation({
            query: ({ id, body }) => ({
                url: `/package/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deletePackage: builder.mutation({
            query: (id) => ({
                url: `/package/${id}`,
                method: "DELETE",
            }),
        }),

        getServicePackages: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/package?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

              updateStatusPackage: builder.mutation({
            query: ({ id, body }) => ({
                url: `/package/status/${id}`,
                method: "PUT",
                body,
            }),
        }),

    }),
});

export const {
    useGetPackagesQuery,
    useGetCategoryBasedServicesMutation,
    useAddPackageMutation,
    useGetSinglePackageQuery,
    useUpdatePackageMutation,
    useDeletePackageMutation,
    useGetServicePackagesQuery, 
    useUpdateStatusPackageMutation
} = packageSlice;
